export enum CookiesNames {
  _TERMS_ACCEPTED = 'termsAccepted',
}
